module.exports = __webpack_public_path__ + "8@2x.9476f33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/8@2x.png
// module id = HPk7
// module chunks = 0